/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import {
    actionsAndNotesWrapper,
    extendedProductTileStyles,
    notesStyles,
    notesWrapper,
} from "@monsma/App/WidgetExtensions/MyListsDetails/MyListsDetailsExtension";
import { staticListProductListLineStyles } from "@monsma/Overrides/Widgets/StaticList/StaticListProductListLine";
import { css } from "styled-components";

(staticListProductListLineStyles as any).extendedProductTileStyles = {
    ...extendedProductTileStyles,
    productTileWrapper: {
        css: css`
            ${extendedProductTileStyles.productTileWrapper?.css};

            &.list-view {
                border: 0;
                border-bottom: 1px solid ${getColor("common.border")};

                &:last-child {
                    border: 0;
                }
            }
        `,
    },
};

(staticListProductListLineStyles as any).notesWrapper = notesWrapper;

(staticListProductListLineStyles as any).actionsAndNotesWrapper = actionsAndNotesWrapper;

staticListProductListLineStyles.notesStyles = notesStyles;
